export type StepCompletionBaseline = {
  ready: boolean;
  completedAt: number | null;
};

export function advanceStepCompletion(
  baseline: StepCompletionBaseline,
  enabled: boolean,
  completedAt: number | null
): { baseline: StepCompletionBaseline; completed: boolean } {
  return {
    baseline: { ready: enabled, completedAt },
    completed:
      enabled &&
      baseline.ready &&
      completedAt !== null &&
      completedAt !== baseline.completedAt,
  };
}
